export const ListQuestion = [
    {
        number: 'I',
        topic: 'Information about Apollo',
        questions: [
            {
                question: 'What is Apollo?',
                answer: 'Apollo by OpenWayBank – Digital Bank is a cooperation project between OpenWayBank and BeGroup. Apollo is a lifetime free digital bank with tons of features. Apollo guarantees to bring you an experience full of fun, convenience and style.'
            },
            {
                question: 'Does Apollo have an app?',
                answer: 'Apollo by OpenWayBank is a Digital Bank available on Android and IOS.'
            },
            {
                question: 'Does Apollo have a branch/transaction office?',
                answer: 'Apollo is a digital bank aimed at the convenience of customers when transacting without a branch. In case customers need support at the counter such as supplementing documents, paying cash, they can go to OpenWay transaction office nationwide.'
            },
            {
                question: 'What is the eKYC process?',
                answer: 'eKYC = Electronic Know Your Customer, is a customer identification process that can be done entirely online using Apollo app. This process includes steps such as filling in customer information, verifying the customer, and performing the signing.'
            },
            {
                question: 'What do I need to do to use Apollo service?',
                answer: 'At Apollo, technology is applied to integrate all the different banking services into one digital platform with the goal of helping you simplify the procedure but still get many benefits.'
            }
        ]
    },
    {
        number: 'II',
        topic: 'Features on Apollo app',
        questions: [
            {
                question: 'How to recharge phone on Apollo?',
                answer: 'To top up your phone, log in to Apollo and follow these steps:',
                steps: [
                    'Click on Telecommunication Service / Select Top Up',
                    'Enter your phone number or the person you want to top up for',
                    'Select the amount to deposit (max. 500,000VND)/ press Continue',
                    'Check Transaction Summary/ press Confirm. It is done! You have successfully recharged your phone!'
                ]
            },
            {
                question: 'Apollo loan?',
                answer: 'Apollo currently has a consumer loan product for customers who are qualified Be drivers and salary advance products for Apollo subscribers.'
            },
            {
                question: 'Apollo has no credit card play?',
                answer: 'Show at Apollo is not support to open the tag signal, in time to when a product card is on the application, Gato will be message on website and fanpage main form of Apollo nha bạn! Gato mời bạn sử dụng các sản phẩm khác nhau trên ứng dụng Apollo nghen!'
            },
            {
                question: 'Can Apollo link momo, zalo pay, or shopee…?',
                answer: 'Okay you. You choose the link channel is MasterCard card. The Apollo Card is that Mastercard!'
            },
            {
                question: 'What is a Apollo VIP account?',
                answer: 'Apollo super is a special type of payment account, only available at Apollo by VPBank Digital Bank with an interest rate of 3.6%/year, which means 36 times the interest rate of a regular current account (0.1%/per year). five).'
            }
        ]
    },
    {
        number: 'III',
        topic: 'Security issue',
        questions: [
            {
                question: 'What do I need to do to protect my account from unauthorized logins?',
                answer: 'You can protect your account in the following ways:',
                steps: [
                    'Set up security for Apollo application by phone and email used to register an account according to the instructions of the service provider (Gmail, Yahoo, ...)',
                    'Do not set up passwords that are too simple, duplicate or related to published personal information',
                    'Regularly change your password every 3 months',
                    'Do not reveal OTP code to anyone'
                ]
            },
            {
                question: 'What should I do if my device is lost or stolen?',
                answer: 'Apollo is sorry if you have unfortunately lost or stolen your device. In this case, you should:',
                steps: [
                    'Contact your telecommunications service provider (Mobifone, Vinaphone, Viettel, ...) to request to lock your mobile phone number to avoid any unauthorized transactions.',
                    'To continue using Apollo services on your new device, you will need to restore your SIM card and re-open your account.'
                ]
            },
            {
                question: 'Is my information safely stored at Apollo?',
                answer: 'Apollo is committed to the complete confidentiality of your information. Apollo only uses the information you provide to serve the purpose of customer verification in accordance with the State Banks regulations.'
            }
        ]
    }
]